import { useRef, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchExamsAdmin, importTestData } from "../../../api/lead";
import ExamTable from "./examTable";
import * as XLSX from "xlsx";
// import FollowupTable from './followupTable';

const Exam = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const loggedInuserType = localStorage.getItem("type");
  const queryParams = new URLSearchParams(location.search);
  const userType = queryParams.get("for");
  const [examData, setExamData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  const fetchExamData = async () => {
    setLoadingData(true);
    try {
      const [examsData] = await Promise.all([fetchExamsAdmin()]);
      // const isForbidden = [examsData].some(
      //     data => [403, 404, 500].includes(data?.status)
      // );
      // if (isForbidden) {
      //     navigate("/internal/lead/login");
      //     return;
      // }
      if (examsData.status) {
        setExamData(examsData.data);
      } else {
        console.warn("Error in fetching the Data");
      }
    } catch (error) {
      console.error("Error in fetching the Data");
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    fetchExamData();
  }, []);

  const handleCreate = () => {
    navigate('/home/create/exam');
  };

  return loadingData == true ? (
    <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4 mt-4">
        <h2 className="mb-0">Examination Stats</h2>
        <button
          type="button"
          className="btn primary-button text-white rounded-pill"
          onClick={handleCreate}
        >
          Create New Test
        </button>
      </div>

      <ExamTable data={examData} />
    </div>
  );
};

export default Exam;
